<app-slide></app-slide>
<div id="middle-header">
   
    <div class="row d-flex">
        <div class=" col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 text-xs-center">
            <div id="school-logo">
                <img src="/assets/img/logo/2.png" alt="School Logo" class="img-fluid border-0">
            </div>
            
            
        </div>
        <div class=" col-sm-3 col-md-3 col-lg-3 col-xl-3  d-none d-sm-block">
            <div class="row d-flex" id="loc">
                <div class="col-11" id="phone">
                    <h4 class="d-flex align-items-center"><div id="logo" class="text-center"><i class="fa fa-phone"></i></div > &nbsp; Call Now</h4>
                    <p class="mb-1">9896776650</p>
                </div>
                
            </div>
            
        </div>
        
    </div>

</div>

<!-- Menu header -->

<div id="menu-header" >
    <nav class="navbar navbar-expand-xl text-light" >
        <button class="navbar-toggler"
            data-toggle="collapse"
            data-target="#menuNav"
            type="button" aria-controls="menuNav" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleMenu()">
            <span class="navbar-toggler-icon text-white"><i class="fas fa-bars" ></i></span>
        </button>
        <div class=" navbar-collapse collapse" id="menuNav">
            <ul class="navbar-nav mx-auto">
                <li class="nav-item" routerLinkActive="active" >
                    <a class="nav-link"  
                    routerLink="/">Home</a>
                </li>
                <li class="nav-item" routerLinkActive="active" >
                    <a class="nav-link"  (click)="toggleMenu()"
                    routerLink="/Mandatory-Public-Disclosure">Mandatory Disclosure</a>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" >ABOUT US</a>
                    <div class="dropdown-menu">
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/about/overview" >OVERVIEW</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/about/chairman">CHAIRMAN'S MESSAGE</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/about/vice-principal">VICE PRINCIPAL'S MESSAGE</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/about/principal">PRINCIPAL'S MESSAGE</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/about/vision">VISION & MISSION</a>
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" >CAMPUS INFRASTRUCTURE</a>
                    <div class="dropdown-menu">
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/campus" >CAMPUS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/computer" >COMPUTER EDUCATION</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/smart" >SMART BONDS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/labs">LABS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/library">LIBRARY</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/activity">ACTIVITY ROOM</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/medical">MEDICAL ROOM </a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/school">SCHOOL COUNSELLOR</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/surveillance">SURVEILLANCE</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/fire">FIRE FIGHTING EQUIPMENT</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/cafeteria">CAFETERIA</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/transport">TRANSPORT</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/infrastructure/herbal">HERBAL GARDEN</a>

                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" >BEYOND EDUCATION</a>
                    <div class="dropdown-menu">
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/academic">ACADEMICS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/examination">EXAMINATIONS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/competition">IH COMPETITIONS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/celebration">CELEBRATIONS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/workshop">WORKSHOPS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/ptm">PTMs</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/trip">EXCURSIONS AND TRIPS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/clubs">CLUBS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/council">STUDENTS' COUNCIL</a>
                        <!-- <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/teacher">KNOW YOUR TEACHERS</a>
                        <a  class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/beyond/coordinators">KNOW YOUR CO-ORDINATORs</a> -->
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" >AWARDS</a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/award/inter">INTER HOUSE RESULTS</a>
                        <a class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/award/star">STAR AWARDEES</a>
                        <a class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/award/notability">NOTABILITY</a>
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" >ADMISSION</a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item"  (click)="toggleMenu()"
                        routerLink="/admission">ADMISSION 2025-26</a>
                        
                    </div>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link"  (click)="toggleMenu()"
                    routerLink="/staff">Staff Details</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link"  (click)="toggleMenu()"
                    routerLink="/gallery">Gallery</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link"  (click)="toggleMenu()"
                     routerLink="/tiny-tots">TINY TOTS</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link"
                     routerLink="/blogs">Blogs</a>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" >ERP Login</a>
                    <div class="dropdown-menu erp-dropdown">
                        <a class="dropdown-item"  (click)="toggleMenu()"
                        (click)="erpLogin('https://school.odpay.in/auth/RPDAV/staff')">Teacher's Login</a>
                        <a class="dropdown-item"  (click)="toggleMenu()"
                        (click)="erpLogin('https://odp.page.link/app')">Student's Login</a>
                        <a class="dropdown-item"  (click)="toggleMenu()"
                        (click)="erpLogin('https://odp.page.link/app')">School App</a>
                        
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</div>

<div id="side-quick-links">
    <ul>
        
        <li class="youtube">
            <div class="content">
                <a href="https://youtube.com/@ramprasadpublicschool9388" target="_blank" class="icons text-white" ><i class="fab fa-youtube"></i></a>
                
                <p><a href="https://youtube.com/@ramprasadpublicschool9388" target="_blank">Youtube</a></p> 
                
                
            </div>
        </li>
        <li class="instagram">
            <div class="content">
                <a href="https://instagram.com/rpdav_school?igshid=YmMyMTA2M2Y=" target="_blank" class="icons text-white" ><i class="fab fa-instagram"></i></a>
                
                <p><a href="https://instagram.com/rpdav_school?igshid=YmMyMTA2M2Y=" target="_blank">Instagram</a></p> 
                
                
            </div>
        </li>
        <li class="facebook">
            <div class="content">
            <a href="https://www.facebook.com/rpdav" class="icons" target="_blank"><i class="fab fa-facebook-square"></i></a>
            <p> <a style="cursor: pointer;" href="https://www.facebook.com/rpdav" target="_blank">Facebook</a></p>

            </div>
        </li>
       
        <li class="call">
            <div class="content">
                <a href="tel:9896776650" class="icons" ><i class="fa fa-phone" aria-hidden="true"></i></a>
                <p><a href="tel:9896776650" >9896776650</a></p>
            </div>
        </li>
       
    </ul>

</div>